const Sucursal = ({ locationName, address, openAt, telephone, whatsappLink, style }) => {
  return (
    <div className="sucursal" style={style}>
      <span className="sucursal-title">{locationName}</span>
      <span className="sucursal-address">{address}</span>
      <div className="sucursal-open-at">
        {locationName && openAt && (
          <img src={require("../../img/horario.png").default} alt=""></img>
        )}
        {openAt && <span>{openAt}</span>}
      </div>
      {!whatsappLink && !telephone ? null :
        whatsappLink ?
        <a href={`https://wa.me/${whatsappLink}`} target="_blank" className="sucursal-whatsapp">
        {locationName && (
          <img src={require("../../img/whatsapp.png").default} alt=""></img>
        )}
        <span>{telephone}</span>
      </a>
        :
        <a href={`tel://${telephone}`} target="_blank" className="sucursal-whatsapp">
          {locationName && (
            <img src={require("../../img/telephone.png").default} alt=""></img>
          )}
          <span>{telephone}</span>
        </a>
      }
    </div>
  );
};

export default Sucursal;
